import { useTextes } from '@common/config';
import { Z_TEXT } from '@common/schemas';

const t = useTextes('Commun', 'PopupEtab');

export const SIRET_REGEX = /^\d{14}$/;

export const Z_SIRET = Z_TEXT(t['POPUP_ETAB_MSG1'])
  .regex(SIRET_REGEX, { error: t['POPUP_ETAB_MSG2'] });